import React, { Component } from "react";
import PropTypes from "prop-types";
import FormLabel from "@material-ui/core/FormLabel";
import "./Form.css";
import { withStyles, createMuiTheme } from "@material-ui/core/styles";
import validate from "../../utils/validate";
import purple from "@material-ui/core/colors/purple";
import green from "@material-ui/core/colors/green";
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import DateFnsUtils from "material-ui-pickers/utils/moment-utils";
import DatePicker from "material-ui-pickers/DatePicker";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import moment from "moment";
import { DATE_FORMAT, MIN_ALLOWED_PICKUP_DAY } from "../../config";

//TODO: extract to utils when service API for holidays is in place
function addBusinessDays(days, holidays) {
  let day = moment();
  holidays = holidays.map(i => i[0]);
  while (days) {
    day = day.add(1, "days");

    if (
      isBusinessDay(day) &&
      holidays.indexOf(day.format("MM/DD/YYYY")) === -1
    ) {
      days--;
    }
  }

  return day.format("MM/DD/YYYY");
}

function disableNonBusinessDays(date, holidays) {
  holidays = holidays.map(i => i[0]);
  if (
    date.isoWeekday() === 6 ||
    date.isoWeekday() === 7 ||
    holidays.indexOf(date.format("MM/DD/YYYY")) >= 0
  ) {
    return true;
  }

  return false;
};

function isBusinessDay(day) {
  var defaultWorkingWeekdays = [1, 2, 3, 4, 5];

  if (defaultWorkingWeekdays.indexOf(day.isoWeekday()) >= 0) return true;

  return false;
}

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  margin: {
    margin: theme.spacing.unit
  },
  cssLabel: {
    "&$cssFocused": {
      color: purple[500]
    }
  },
  cssFocused: {},
  cssUnderline: {
    "&:after": {
      borderBottomColor: purple[500]
    }
  },
  bootstrapRoot: {
    padding: 0,
    "label + &": {
      marginTop: theme.spacing.unit * 3
    },
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "2px 10px 2px 10px",
    width: "calc(100%) - 20px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  },
  bootstrapError: {
    border: "1px solid red"
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 12px",
    width: "calc(100%)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    }
  },
  bootstrapFormLabel: {
    fontSize: 18
  }
});

const theme = createMuiTheme({
  palette: {
    primary: green
  }
});

class DateField extends Component {
  state = {
    error: false,
    errorMessage: ""
  };
  componentDidMount() {
    this.validateFn(this.props.value);
  }

  handleChange = value => {
    this.validateFn(value.format(DATE_FORMAT));
  };

  validateFn(value) {
    let errorObj = validate(value, this.props.required, this.props.regEx);
    this.setState(() => errorObj);

    if (this.props.onChanged) {
      this.props.onChanged(value, errorObj.error);
    }
  }

  render() {
    const {
      type,
      label,
      name,
      value,
      placeholder,
      editable,
      required,
      showError,
      yardProps,
      classes
    } = this.props;
    return (
      <div>
        <FormLabel className="radio-group-label">{label}</FormLabel>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            name={name}
            minDate={addBusinessDays(MIN_ALLOWED_PICKUP_DAY, yardProps.holidays)}
            maxDate={addBusinessDays(
              yardProps.maxAllowedPickupDays,
              yardProps.holidays
            )}
            value={value ? moment(value, DATE_FORMAT).toDate() : null}
            shouldDisableDate={date => disableNonBusinessDays(date, yardProps.holidays)}
            disablePast
            autoOk
            placeholder={placeholder}
            onChange={this.handleChange}
            margin="normal"
            format={DATE_FORMAT}
            style={{ width: "100%" }}
            disabled={!editable}
            required={required}
            error={this.state.error && showError}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Icon>calendar_today</Icon>
                </InputAdornment>
              ),
              classes: {
                root: classes.bootstrapRoot,
                error: classes.bootstrapError
              }
            }}
            animateYearScrolling={false}
          />
        </MuiPickersUtilsProvider>

        {this.state.error && showError ? (
          <span className="error-text">({this.state.errorMessage})</span>
        ) : (
            ""
          )}
      </div>
    );
  }
}

DateField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  onChanged: PropTypes.func
};

export default withStyles(styles)(DateField);



// WEBPACK FOOTER //
// ./src/components/form/DateField.js